import { SpinResponse, FreeSpinsInfoEvent } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { ResumeRule } from './infra/resume_rule';

export class BonusToEndCustomFreeSpins<
  TResponse extends SpinResponse,
> extends ResumeRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    return (
      !resp.curResponse.isScatter &&
      !!resp.curResponse.freeSpinsInfo &&
      resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsFinished
    );
  }
}
